let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kbzD1")).then(() => parcelRequire('aFOyu'));